
<div>
    <v-progress-linear v-if="busy" absolute indeterminate></v-progress-linear>

    <card-unit :items="items">
        <template #title>{{ t('user_label_bubble_allowance') }}</template>
    </card-unit>

    <v-card class="app-card mt-4" v-if="data">
        <v-card-title>{{ t('user_label_bubble_grant_credits') }}</v-card-title>
        <v-card-text>
            <p class="text-caption mb-4">{{ t('user_text_bubble_grant_hint', { period: data.period }) }}</p>
            <v-text-field
                v-model.number="form.credits"
                type="number"
                min="1"
                outlined
                dense
                :label="t('user_label_bubble_credits')"
                :error-messages="form.errors.get('credits')"
            ></v-text-field>
            <v-text-field
                v-model="form.note"
                outlined
                dense
                :label="t('user_label_bubble_grant_note')"
                :error-messages="form.errors.get('note')"
            ></v-text-field>
            <v-btn color="primary" class="sm" :disabled="! form.credits || form.busy" @click="submit">
                {{ t('user_action_bubble_grant') }}
            </v-btn>

            <v-simple-table v-if="data.grants.length > 0" class="mt-6" dense>
                <thead>
                <tr>
                    <th>{{ t('user_label_bubble_credits') }}</th>
                    <th>{{ t('user_label_bubble_grant_note') }}</th>
                    <th>{{ t('general_label_created_by') }}</th>
                    <th>{{ t('general_label_created') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="grant in data.grants" :key="grant.id">
                    <td>+{{ grant.credits }}</td>
                    <td>{{ grant.note || '-' }}</td>
                    <td>{{ grant.granted_by || '-' }}</td>
                    <td>{{ moment(grant.created_at).format('DD/MM/YYYY HH:mm') }}</td>
                </tr>
                </tbody>
            </v-simple-table>
        </v-card-text>
    </v-card>
</div>
